const SCOPE = Symbol(0);

export { SCOPE };
